import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import { setThreatFilter } from '~app/actions/wildlife';

import { insertInnerDividers } from '~app/core/dividerUtils';

import Divider from './Divider';
import WildlifeThreatFilterCell from './WildlifeThreatFilterCell';

class WildlifeThreatLevelSelector extends Component {

  render() {
    return (
      <div className="WildlifeThreatLevelSelector">
        {this.renderThreatCells()}
      </div>
    );
  }

  renderThreatCells() {
    return insertInnerDividers(
      this.props.threatLevelCounts.map(::this.renderThreatCell),
      <Divider styleName="WildlifeThreatLevelSelector__divider" />
    );
  }

  renderThreatCell(threatLevelCount) {
    // Return a dummy cell.
    return (
      <WildlifeThreatFilterCell
        key={threatLevelCount.levelName}
        enabled={(threatLevelCount.levelCode & this.props.activeThreatFilter) !== 0}
        threatLevelName={threatLevelCount.levelName}
        speciesCount={threatLevelCount.speciesCount}
        onToggle={(nextEnabled) =>
          this.updateActiveThreatLevels(nextEnabled, threatLevelCount.levelCode)}
      />
    );
  }

  updateActiveThreatLevels(enable, levelCode) {
    let nextThreatFilter = this.props.activeThreatFilter;
    if (enable) {
      nextThreatFilter |= levelCode;
    }
    else {
      nextThreatFilter &= (~levelCode);
    }
    this.props.setThreatFilter(this.props.wildlifeContext, nextThreatFilter);
  }
}

WildlifeThreatLevelSelector.propTypes = {
  wildlifeContext: PropTypes.string.isRequired,
  activeThreatFilter: PropTypes.number.isRequired,
  threatLevelCounts: PropTypes.array.isRequired,
};

const mapStateToProps = (state, {wildlifeContext}) => ({
  activeThreatFilter: state.wildlife[wildlifeContext].activeThreatFilter,
  threatLevelCounts: state.wildlife[wildlifeContext].threatLevelCounts,
});

const mapDispatchToProps = {
  setThreatFilter,
};

export { WildlifeThreatLevelSelector };
export default connect(mapStateToProps, mapDispatchToProps)(WildlifeThreatLevelSelector);



// WEBPACK FOOTER //
// ./src/components/WildlifeThreatLevelSelector.js